import axios from 'axios';
import { Ranking, RankingItem } from '../types';

// 设置 API 基础 URL
const API_BASE_URL = `https://www.dooocs.com/api`;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 排行榜 API
export const rankingsApi = {
  getAll: () => api.get<Ranking[]>('/rankingList/lists'),
  getById: (id: string) => api.get<Ranking>(`/rankingList/lists/${id}`),
  create: (ranking: { title: string; description: string; coverUrl: string; creatorId: string }) => 
    api.post<Ranking>('/rankingList/create', ranking),
  update: (id: string, ranking: Partial<Ranking>) => 
    api.put<Ranking>(`/rankingList/lists/${id}`, ranking),
  delete: (id: string) => api.post(`/rankingList/lists/${id}/delete`),
};

// 榜单项目 API
export const rankingItemsApi = {
  getByRankingId: (rankingId: string) => 
    api.get<RankingItem[]>(`/rankingList/lists/${rankingId}/items`),
  create: (item: Omit<RankingItem, 'id' | 'createdAt' | 'updatedAt'>) => 
    api.post<RankingItem>('/rankingList/items', item),
  update: (id: string, item: Partial<RankingItem>) => 
    api.put<RankingItem>(`/rankingList/items/${id}`, item),
  delete: (id: string) => api.post(`/rankingList/items/${id}/delete`),
  getById: (id: string) => api.get<RankingItem>(`/rankingList/items/${id}`),
};

// 首页 API - 由于后端没有专门的首页 API，我们使用排行榜 API 来获取数据
export const homeApi = {
  getAllHomeData: async () => {
    const response = await rankingsApi.getAll();
    const allRankings = response.data;
    
    // 将所有榜单分为三类：推荐、最新和热门
    // 这里简单地按照索引分类，实际项目中可能需要根据其他属性分类
    const featuredRankings = allRankings.slice(0, Math.min(3, allRankings.length));
    const latestRankings = allRankings.slice(0, Math.min(100, allRankings.length));
    const popularRankings = allRankings.slice(0, Math.min(4, allRankings.length));
    
    return {
      data: {
        featuredRankings,
        latestRankings,
        popularRankings
      }
    };
  }
};

// 不再需要模拟数据的拦截器，直接使用真实 API
export default api;